<ng-template #loading>
  <p>Carregando...</p>
</ng-template>
<div *ngIf="infosInstitucionais$ | async as infos; else loading" class="mt-4">
  <div *ngIf="showTitle" class="mb-2">
    <bdg-label type="title">Informações institucionais</bdg-label>
  </div>
  <div class="{{ 'row ' + (showTitle ? 'mt-4' : 'mt-n3') }}">
    <div class="col-3">
      <bdg-info-label label="Nome da instituição" data-testid="label-nome-instituicao">{{
        infos.nomeInstituicao
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="CNPJ" data-testid="label-cnpj">{{ infos.cnpj | cnpj }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="Razão social" data-testid="label-razao-social">{{ infos.razaoSocial }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="Natureza jurídica" data-testid="label-natureza-juridica">{{
        infos.naturezaJuridica
      }}</bdg-info-label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <bdg-info-label label="{{ 'Coordenador da ' + infos.siglaComissao }}" data-testid="label-coordenador-comissao">{{
        infos.coordenadorComissao
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="CPF do coordenador" data-testid="label-cpf-coordenador">{{
        infos.cpfCoordenador | cpf
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="E-mail do coordenador" data-testid="label-email-coordenador">{{
        infos.emailCoordenador
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="Celular do coordenador" data-testid="label-celular-coordenador">{{
        infos.celularCoordenador | telefone
      }}</bdg-info-label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <bdg-info-label label="{{ 'Contato ' + infos.siglaComissao }}" data-testid="label-contato-coordenador">{{
        infos.contatoComissao
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="Telefone institucional" data-testid="label-telefone-institucional">{{
        infos.telefoneComissao | telefone
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="E-mail institucional" data-testid="label-email-institucional">{{
        infos.emailComissao
      }}</bdg-info-label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <bdg-info-label label="Logradouro" data-testid="label-logradouro">{{
        infos.logradouroComissao + (infos.hasNumero ? ', ' + infos.numeroComissao : '')
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="UF" data-testid="label-uf">{{ infos.ufComissao }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="Município" data-testid="label-municipio">{{ infos.municipioComissao }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="Bairro" data-testid="label-bairro">{{ infos.bairroComissao }}</bdg-info-label>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <bdg-info-label label="Complemento" data-testid="label-complemento">{{
        infos.complementoComissao
      }}</bdg-info-label>
    </div>
    <div class="col-3">
      <bdg-info-label label="CEP" data-testid="label-cep">{{ infos.cepComissao | cep }}</bdg-info-label>
    </div>
  </div>
</div>
